var angular = require('angular');
angular.module('pitch.search', [
    //this uses pitch.app - and pitch.app uses this - is this correct. For now it seems to work?
    //@todo Move some shared functionality in core module.
    'pitch.app',
    'satv.search',
    'ui.router'
])

.config(function($stateProvider, config) {

    //template helper
    function tpl(t) {
        return config.templateRoot + '/' + t + '?version=' + config.app_release_id;
    }

    $stateProvider
        .state('search', {
            url: "/search?textQuery&{sortBy:string}&{sortOrder:string}&{fields:string}&{keywordIds:int}&{categoryIds:int}&{versionIds:int}&{entityCodes}&{bpmMinimum:int}&{bpmMaximum:int}&{yearMinimum:int}&{yearMaximum:int}&entity&{territoryId:int}&{controlMinimumPercentage:int}&{chartTerritoryId:int}&{chartPosition:int}&{chartYearFrom:int}&{chartYearTo:int}&{originatingOfficeId:int}&{labelId:int}&{tempoSongId:string}&{trackId:string}&{origId:string}",
            templateUrl: tpl('templates/search'),
            controller: 'PitchSearchCtrl',
            parent: 'root',
            resolve: {
                searchLoader: function(SearchLoader, $stateParams) {
                    return new SearchLoader(
                        angular.copy($stateParams)
                    );
                }
            }
        })
    ;
});



// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/angular/app.js